import { http } from "../../../services/apiSecurity/Http.interceptor";
import { ResponsePagination } from "../../../core/interfaces/ResponsePagination";
import { Region } from "./interfaces/Region";

const URL: string = '/regions';

export const getRegion = (params?: any) => {
    return http.get<ResponsePagination>(URL, { params: params });
}

export const getByRegion = (id: number) => {
    return http.get<Region>(`${URL}/${id}`)
}

export const postRegion = (data: Region) => {
    return http.post<Region>(URL, data)
}

export const deleteRegion = (id: number) => {
    return http.delete<string>(`${URL}/${id}`)
}

export const putRegion = (data: Region) => {
    return http.put<Region>(`${URL}/${data.id}`, data)
}

export const getAllRegion = (params?: any) => {
    return http.get<Region[]>(`/listAllRegions`, {params: params})
}